// extracted by mini-css-extract-plugin
export var emailBlockLink = "_fj-0";